/* ⚠ GENERADO por plan_web/sync-tema.mjs — la fuente de verdad es plan_web/s7.js */
/* ═══════════════════════════════════════════════════════════════════════════
   SEVEN 7REES — comportamiento del sistema «Pliego»
   Tres cosas y ninguna más: la firma de movimiento, la forma de onda y el
   reproductor A/B. Sin dependencias, sin framework, sin CDN.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Una sola instancia por página. El snippet `s7-tokens` se renderiza en el
     <head> del layout y además dentro de algunas secciones, así que el mismo
     <script> puede llegar dos veces: el navegador no deduplica por URL y cada
     copia registraría sus propios oyentes. En el reproductor A/B eso se ve
     como un botón muerto — el primer oyente hace play() y el segundo, que ya
     encuentra el audio sonando, hace pause() en el mismo click. */
  if (window.__s7) return;
  window.__s7 = true;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── La firma: el barrido ──────────────────────────────────────────── */
  function barrido() {
    var piezas = document.querySelectorAll('.s7-barrido, .s7-filete-vivo');
    if (!piezas.length) return;
    if (quieto || !('IntersectionObserver' in window)) {
      piezas.forEach(function (p) { p.classList.add('s7-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('s7-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    // Revela todo lo que ya cruzó el borde inferior. Es la red de seguridad:
    // un salto instantáneo de scroll (ancla, Ctrl+F, restauración de posición)
    // no genera cambios de intersección para lo que se saltó, y esas piezas se
    // quedarían invisibles para siempre. Con un CTA que apunta a #precio, eso
    // es contenido de venta que no se ve.
    function revelarLoPasado() {
      var quedan = 0;
      piezas.forEach(function (p) {
        if (p.classList.contains('s7-visible')) return;
        if (p.getBoundingClientRect().top < window.innerHeight) {
          p.classList.add('s7-visible');
          obs.unobserve(p);
        } else quedan++;
      });
      return quedan;
    }

    piezas.forEach(function (p) { obs.observe(p); });

    var pendiente = false;
    function alHacerScroll() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        if (revelarLoPasado() === 0) window.removeEventListener('scroll', alHacerScroll);
      });
    }
    window.addEventListener('scroll', alHacerScroll, { passive: true });
    revelarLoPasado();
  }

  /* ── Escalonado automático ─────────────────────────────────────────────
     Numera los hijos de cada .s7-cascada para que entren uno tras otro. Se
     hace en JS y no a mano porque marcar --2/--3 pieza por pieza es la razón
     de que la home tuviera 8 elementos con movimiento en 8.000px de alto.  */
  function cascada() {
    document.querySelectorAll('.s7-cascada').forEach(function (caja) {
      var i = 0;
      [].forEach.call(caja.children, function (hijo) {
        if (!hijo.classList.contains('s7-barrido')) return;
        hijo.style.setProperty('--s7-i', i++);
      });
    });
  }

  /* ── Las cifras cuentan ────────────────────────────────────────────────
     Sube hasta el número que ya está escrito en el HTML, conservando prefijo
     y sufijo ("17M+", "+200", "5.0"). El texto final se restaura siempre al
     terminar, así que un error de parseo nunca deja un dato a medias.     */
  function contador(el) {
    var texto = el.textContent.trim();
    var m = texto.match(/^(\D*?)([\d.,]+)(.*)$/);
    if (!m) return;
    var antes = m[1], crudo = m[2], despues = m[3];
    var decimales = (crudo.split(/[.,]/)[1] || '').length;
    var sep = crudo.indexOf(',') > -1 ? ',' : '.';
    var destino = parseFloat(crudo.replace(',', '.'));
    if (!isFinite(destino)) return;

    var dur = 900, t0 = 0;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var suave = 1 - Math.pow(1 - p, 3);          // se frena al llegar
      var v = (destino * suave).toFixed(decimales);
      el.textContent = antes + (sep === ',' ? v.replace('.', ',') : v) + despues;
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = texto;                  // el original, sin excusas
    }
    requestAnimationFrame(paso);
  }

  function cifras() {
    var nums = document.querySelectorAll('.s7-cifra');
    if (!nums.length || quieto || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        contador(e.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ── Forma de onda ─────────────────────────────────────────────────────
     Dibuja la envolvente de una canción: entra, sube, cae en el puente y
     remata. No es aleatoria: la caída del puente es lo que la hace leerse
     como música y no como ruido.                                        */
  function onda(lienzo) {
    var alto = lienzo.clientHeight || 92;
    var ancho = lienzo.clientWidth || 800;
    var dpr = window.devicePixelRatio || 1;
    lienzo.width = ancho * dpr;
    lienzo.height = alto * dpr;
    var g = lienzo.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, ancho, alto);

    var estilo = getComputedStyle(lienzo);
    var acento = estilo.getPropertyValue('--s7-acento').trim() || '#D92B12';
    var tenue = estilo.getPropertyValue('--s7-texto-2').trim() || '#5B5F58';

    var barras = Math.floor(ancho / 3);
    var medio = alto / 2;
    for (var i = 0; i < barras; i++) {
      var t = i / barras;
      var env = 0.30 + 0.44 * Math.sin(Math.PI * Math.pow(t, 0.72))
              + 0.16 * Math.sin(t * 34) + 0.10 * Math.sin(t * 111);
      if (t > 0.60 && t < 0.71) env *= 0.42;       // el puente
      var h = Math.max(2, Math.min(1, Math.abs(env)) * (alto - 12));
      g.fillStyle = t < 0.34 ? acento : tenue;
      g.globalAlpha = t < 0.34 ? 1 : 0.45;
      g.fillRect(i * 3, medio - h / 2, 2, h);
    }
    g.globalAlpha = 1;
  }

  function ondas() {
    var lienzos = document.querySelectorAll('.s7-onda canvas');
    if (!lienzos.length) return;
    lienzos.forEach(onda);
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { lienzos.forEach(onda); }, 160);
    });
  }

  /* ── Reproductor A/B ───────────────────────────────────────────────────
     Dos fuentes, un solo transporte: al cambiar de versión se mantiene el
     punto de reproducción, que es lo único que hace útil una comparación.

     Y un solo transporte en toda la página: la sección existe para comparar
     mezclas, así que dos comparadores sonando a la vez no suman información,
     la tapan. El que arranca detiene al que estaba sonando. */
  var enMarcha = null;

  function reproductorAB(caja) {
    var audios = caja.querySelectorAll('audio');
    var play = caja.querySelector('.s7-ab__play');
    var pista = caja.querySelector('.s7-ab__pista b');
    var botones = caja.querySelectorAll('.s7-ab__conmutador button');
    if (!audios.length || !play) return;
    if (caja.dataset.s7ab) return;   // ya cableada (editor de temas, re-render)
    caja.dataset.s7ab = '1';
    var activo = 0;

    function actual() { return audios[activo]; }

    var mando = { detener: detener };

    function detener() {
      actual().pause();
      play.textContent = '▶';
      if (enMarcha === mando) enMarcha = null;
    }

    play.addEventListener('click', function () {
      if (!actual().paused) { detener(); return; }
      if (enMarcha && enMarcha !== mando) enMarcha.detener();
      enMarcha = mando;
      actual().play();
      play.textContent = '❚❚';
    });

    botones.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (i === activo) return;
        var punto = actual().currentTime;
        var seguia = !actual().paused;
        actual().pause();
        activo = i;
        botones.forEach(function (o, j) { o.setAttribute('aria-pressed', String(j === i)); });
        actual().currentTime = punto;          // el punto se conserva
        if (seguia) { enMarcha = mando; actual().play(); }
      });
    });

    audios.forEach(function (a) {
      a.addEventListener('timeupdate', function () {
        if (a !== actual() || !a.duration) return;
        if (pista) pista.style.width = (a.currentTime / a.duration) * 100 + '%';
      });
      a.addEventListener('ended', function () {
        if (a !== actual()) return;
        play.textContent = '▶';
        if (enMarcha === mando) enMarcha = null;   // libera el turno
      });
    });
  }


  /* ── El titular entra por palabras ─────────────────────────────────────
     El cartel es lo único que decide si alguien se queda; entraba con el
     mismo barrido que un párrafo cualquiera. Se parte AQUÍ y no en el
     Liquid a propósito: el HTML que sirve el servidor sigue teniendo el
     titular entero, así que sin JS —o con este script caído— se lee
     completo desde el primer fotograma. Es contenido, no adorno.

     Un `.s7-destacado` NO se parte: el resaltador de cal pinta el fondo del
     span entero y trocearlo lo dejaría a rayas. Entra como una palabra más. */
  function titular() {
    var carteles = document.querySelectorAll('.l-hero__cartel');
    if (!carteles.length) return;

    carteles.forEach(function (h) {
      if (h.dataset.s7Palabras) return;
      var piezas = [];

      [].slice.call(h.childNodes).forEach(function (nodo) {
        if (nodo.nodeType === 3) {
          nodo.textContent.split(/(\s+)/).forEach(function (trozo) {
            if (!trozo) return;
            if (!trozo.trim()) { piezas.push(document.createTextNode(trozo)); return; }
            var p = document.createElement('span');
            p.className = 's7-palabra';
            p.textContent = trozo;
            piezas.push(p);
          });
        } else if (nodo.nodeType === 1 && nodo.tagName === 'BR') {
          piezas.push(nodo.cloneNode(true));
        } else if (nodo.nodeType === 1) {
          var env = document.createElement('span');
          env.className = 's7-palabra';
          env.appendChild(nodo.cloneNode(true));
          piezas.push(env);
        }
      });

      var palabras = piezas.filter(function (p) { return p.nodeType === 1 && p.className === 's7-palabra'; });
      if (palabras.length < 2) return;   // nada que escalonar

      h.textContent = '';
      piezas.forEach(function (p) { h.appendChild(p); });
      palabras.forEach(function (p, i) { p.style.setProperty('--s7-p', i); });

      // El barrido y el troceo son dos formas de entrar y juntas se pelean:
      // una recorta la caja, la otra levanta las palabras de dentro.
      h.classList.remove('s7-barrido');
      h.classList.add('s7-letra-viva');
      h.dataset.s7Palabras = '1';

      if (quieto || !('IntersectionObserver' in window)) { h.classList.add('s7-visible'); return; }
      var obs = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        h.classList.add('s7-visible');
        obs.disconnect();
      }, { threshold: 0.2 });
      obs.observe(h);
      // El hero suele estar ya en pantalla al cargar: sin esta línea
      // esperaría a un scroll que quizá no llega nunca.
      if (h.getBoundingClientRect().top < window.innerHeight) h.classList.add('s7-visible');
    });
  }

  /* ── El cabezal de la regla ────────────────────────────────────────────
     Cruza la regla de compases una vez, cuando entra en pantalla. Una vez y
     no en bucle: el medidor de la cabecera ya es el elemento que se mueve
     solo del sitio, y dos animaciones permanentes en la misma página la
     convierten en un banner. */
  function regla() {
    var reglas = document.querySelectorAll('.s7-regla');
    if (!reglas.length || quieto || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('s7-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    reglas.forEach(function (r) { obs.observe(r); });
  }

  /* ── La barra fija entra cuando el hero se va ──────────────────────────
     Estaba pegada abajo desde el primer píxel: una segunda llamada a
     comprar tapando el hero antes de haber dicho qué se vende. Ahora entra
     cuando el hero sale de pantalla, justo cuando el visitante perdió de
     vista el botón que tenía.

     Si algo de esto falla, la barra se queda visible: la clase que la
     esconde la pone este script, no el HTML. Nunca se pierde el botón. */
  function stickyAuto() {
    var barra = document.querySelector('.s7-sticky');
    var hero = document.querySelector('.l-hero');
    if (!barra || !hero || !('IntersectionObserver' in window)) return;

    barra.classList.add('s7-sticky--auto');
    var obs = new IntersectionObserver(function (e) {
      barra.classList.toggle('s7-sticky--dentro', !e[0].isIntersecting);
    }, { threshold: 0, rootMargin: '-60px 0px 0px 0px' });
    obs.observe(hero);
  }

  /* ── Previews del curso por dentro ─────────────────────────────────────
     Capturas de pantalla en cámara rápida. Se comportan como un GIF —sin
     sonido, en bucle— pero solo mientras están a la vista: fuera de
     pantalla se paran, y con preload="none" no se descargan hasta que
     alguien llega ahí. Cuatro videos arrancando en la carga costarían
     varios megas a quien nunca baja hasta esta sección.

     play() devuelve una promesa que el navegador rechaza si bloquea la
     reproducción automática. Se traga a propósito: un preview que no
     arranca deja la miniatura, que ya es contenido.

     08/09/2026 — Se añade `.l-etapa__clip`. Los clips del temario pasaron
     de ser una tira suelta (`.l-preview`) a vivir dentro de las tarjetas
     de etapa, y esta función seguía buscando solo el selector viejo: las
     cuatro tarjetas quedaban en negro para siempre. Medido antes del
     arreglo: `readyState 0`, `paused`, 0 bytes descargados incluso con la
     tarjeta a la vista. Un selector que ya no existe no falla — sale del
     paso en silencio, que es peor. */
  function previews() {
    var videos = document.querySelectorAll('.l-preview video, .l-etapa__clip video');
    if (!videos.length) return;
    if (quieto || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.35 });
    videos.forEach(function (v) { obs.observe(v); });
  }

  /* ── Contador regresivo ────────────────────────────────────────────────
     El servidor imprime en data-fin el instante de cierre (epoch, en la
     zona horaria de la tienda) Y el plazo ya escrito dentro de la pieza.
     Sin JS la ficha sigue diciendo «Quedan 16 días»; con JS el reloj toma
     el relevo y se retira ese texto, para que la misma pieza no diga el
     plazo dos veces.

     LO QUE NO CAMBIA: la cuenta va contra una FECHA FIJA del servidor, no
     contra la primera visita. Un contador por cookie se reinicia al
     borrarla y le enseña al que vuelve que el cierre es mentira. Aquí el
     que vuelve mañana ve un día menos. */
  function cuenta() {
    var fichas = document.querySelectorAll('[data-s7-cuenta]');
    if (!fichas.length) return;

    fichas.forEach(function (ficha) {
      var fin = parseInt(ficha.getAttribute('data-fin'), 10);
      var ini = parseInt(ficha.getAttribute('data-ini'), 10) || 0;
      var reloj = ficha.querySelector('.s7-oferta__reloj');
      var estado = ficha.querySelector('.s7-oferta__estado');
      var barra = ficha.querySelector('.s7-oferta__barra i');
      if (!fin || !reloj) return;
      if (fin * 1000 - Date.now() <= 0) return;   // ya cerrada: manda el servidor

      var celdas = {};
      ['d', 'h', 'm', 's'].forEach(function (u) {
        celdas[u] = reloj.querySelector('[data-u="' + u + '"]');
      });
      if (!celdas.d || !celdas.h || !celdas.m || !celdas.s) return;

      reloj.hidden = false;
      // La frase NO se esconde con hidden: eso la sacaría también del árbol
      // de accesibilidad, y es lo único que un lector de pantalla puede
      // anunciar de forma útil («Quedan 16 días» en vez de cuatro números
      // sueltos). Se saca solo de la vista.
      if (estado) estado.classList.add('s7-solo-lector');

      function pinta(el, valor) {
        var txt = valor < 10 ? '0' + valor : String(valor);
        if (el.textContent === txt) return;
        el.textContent = txt;
        if (quieto) return;
        el.classList.remove('s7-salta');
        void el.offsetWidth;              // reinicia la animación
        el.classList.add('s7-salta');
      }

      function tic() {
        var restan = Math.floor((fin * 1000 - Date.now()) / 1000);

        if (restan <= 0) {
          clearInterval(timer);
          ficha.classList.add('s7-oferta--cerrada');
          if (estado) {
            estado.classList.remove('s7-solo-lector');
            estado.innerHTML = '<b>La oferta cerró</b>';
          }
          return;
        }

        pinta(celdas.d, Math.floor(restan / 86400));
        pinta(celdas.h, Math.floor(restan / 3600) % 24);
        pinta(celdas.m, Math.floor(restan / 60) % 60);
        pinta(celdas.s, restan % 60);

        // Últimas 48 h: el único momento en que la pieza sube la voz. El
        // servidor ya la marca al renderizar; esto la marca también en la
        // pestaña que lleva abierta desde antes de cruzar el umbral.
        if (restan < 172800) ficha.classList.add('s7-oferta--cierre');

        if (barra && ini && fin > ini) {
          var pct = Math.min(100, Math.max(0, ((Date.now() / 1000 - ini) / (fin - ini)) * 100));
          barra.style.width = pct.toFixed(2) + '%';
        }
      }

      var timer = setInterval(tic, 1000);
      tic();
    });
  }

  /* ── Motion, y solo si hay algo que animar ─────────────────────────────
     motion.dev pesa 47 KB comprimido. Se carga DESPUÉS de todo lo demás,
     solo en páginas que tengan piezas que lo usen, y cada efecto parte de
     un estado ya visible: si el archivo no llega —red caída, bloqueador,
     navegador viejo— la página se ve igual, solo sin el movimiento ligado
     al scroll. Nada de contenido de venta depende de él.

     Qué se le pide, y por qué no se hace en CSS: el crecimiento de las
     regiones del temario con resorte, y el desplazamiento ligado al
     PROGRESO del scroll —no a un disparo al entrar—, que es lo que CSS
     todavía no da de forma portable. */
  function conMotion() {
    if (quieto) return;
    var url = window.S7_MOTION;
    if (!url) return;

    var regiones = document.querySelectorAll('.s7-region');
    var fondos = document.querySelectorAll('[data-s7-fondo]');
    if (!regiones.length && !fondos.length) return;

    function aplica() {
      var M = window.Motion;
      if (!M || !M.animate) return;

      // El temario ES una línea de tiempo de DAW: sus regiones se dibujan
      // creciendo desde la izquierda, en el orden en que van en el curso.
      //
      // Las regiones ya vienen del HTML con el barrido del sistema, que es
      // justo lo que las salva si este archivo no llega. Ahora que sí
      // llegó, se les quita: dos entradas a la vez —una recortando la caja,
      // otra estirándola— se pisan. El relevo se hace aquí y no antes,
      // porque antes no había con qué relevar.
      if (regiones.length && M.inView) {
        regiones.forEach(function (r, i) {
          if (r.getBoundingClientRect().top < window.innerHeight) return;  // ya entró: no se rebobina
          r.classList.remove('s7-barrido', 's7-visible');
          r.style.clipPath = 'none';
          r.style.transformOrigin = 'left center';
          r.style.opacity = '0';
          M.inView(r, function () {
            M.animate(r,
              { transform: ['scaleX(0.04)', 'scaleX(1)'], opacity: [0, 1] },
              { duration: 0.7, delay: (i % 4) * 0.08, type: 'spring', bounce: 0.18 });
          }, { amount: 0.4 });
        });
      }

      // Desplazamiento ligado al progreso del scroll. Corto a propósito:
      // un parallax que se nota es un parallax de plantilla.
      if (fondos.length && M.scroll) {
        fondos.forEach(function (el) {
          M.scroll(
            M.animate(el, { y: ['-3%', '3%'] }, { ease: 'linear' }),
            { target: el, offset: ['start end', 'end start'] });
        });
      }
    }

    function carga() {
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = aplica;
      s.onerror = function () {};   // silencio: el respaldo es no hacer nada
      document.head.appendChild(s);
    }

    if ('requestIdleCallback' in window) requestIdleCallback(carga, { timeout: 2500 });
    else setTimeout(carga, 1200);
  }

  /* ── El póster del vídeo se pulsa ──────────────────────────────────── */
  function vslClic() {
    document.querySelectorAll('.l-vsl').forEach(function (caja) {
      var v = caja.querySelector('video');
      if (!v) return;
      caja.classList.add('l-vsl--pulsable');
      function arranca(e) {
        // La barra de controles nativa vive en la franja de abajo y ya la
        // gestiona el navegador: un clic ahí no es «quiero ver el vídeo».
        var r = v.getBoundingClientRect();
        if (e.clientY > r.bottom - 56) return;
        caja.removeEventListener('click', arranca);
        caja.classList.remove('l-vsl--pulsable');
        v.preload = 'auto';
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      caja.addEventListener('click', arranca);
    });
  }

  function arranca() {
    cascada();      // antes del barrido: reparte los retardos
    titular();      // antes del barrido: le quita la clase al cartel
    barrido();
    regla();
    stickyAuto();
    previews();
    cuenta();
    cifras();
    ondas();
    vslClic();
    document.querySelectorAll('.s7-ab').forEach(reproductorAB);
    conMotion();    // el último: carga en reposo y nada depende de él
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();
